import { render } from "./create-index.vue?vue&type=template&id=7f5b3a8a"
import script from "./create-index.vue?vue&type=script&lang=js"
export * from "./create-index.vue?vue&type=script&lang=js"

import "./create-index.vue?vue&type=style&index=0&id=7f5b3a8a&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__